import Vue from 'vue'

Vue.component('BaseInput',
  () => import('@/components/Base/BaseInput.vue')
)
Vue.component('BaseSelect',
  () => import('@/components/Base/BaseSelect.vue')
)
Vue.component('BaseRadioInput',
  () => import('@/components/Base/BaseRadioInput.vue')
)
Vue.component('BaseAddSection',
  () => import('@/components/Base/BaseAddSection.vue')
)
Vue.component('BaseFileUpload',
  () => import('@/components/Base/BaseFileUpload.vue')
)

Vue.component('BaseDatePicker',
  () => import('@/components/Base/BaseDatePicker.vue')
)

Vue.component('ButtonLink',
  () => import('@/components/common/ButtonLink.vue')
)
